<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getChargeDetails)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getChargeDetails)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getChargeDetails, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getChargeDetails, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/chargeSchedulePerson', '员工收费明细统计')"
          icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 收费明细统计列表 -->
      <el-table v-loading="loading" :data="chargeDetailsList" :max-height="tableHeight" border>
        <el-table-column label="患者姓名" prop="patientName" fixed/>
        <el-table-column label="订单号" prop="orderNumber" min-width="200" fixed/>
        <el-table-column label="收费时间" prop="payTime" min-width="140"/>
        <el-table-column label="订单来源" prop="source"/>
        <el-table-column label="订单原价(元)" prop="totalPrice" min-width="110"/>
        <el-table-column label="优惠(元)" prop="discountPrice"/>
        <el-table-column label="折扣" prop="discount"/>
        <el-table-column label="应收(元)" prop="realPay" min-width="100"/>
        <el-table-column label="实收(元)" prop="prepaid" min-width="100"/>
        <!-- <el-table-column label="成本(元)" prop="cost"/>
        <el-table-column label="毛利(元)" prop="maoriForehead"/>
        <el-table-column label="毛利率" prop="grossProfitMargin"/> -->
        <el-table-column label="支付方式" prop="payWay"/>
        <el-table-column label="收费员" prop="payee" fixed="right"/>
        <el-table-column label="销售员" prop="createBy" fixed="right"/>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getChargeDetails)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import axios from 'axios';
import { chargeDetails1 } from "@/api/statement"; // 报表统计请求
export default {
  name: 'StaffChargeDetails',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      chargeDetailsList: [], // 收费明细统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getChargeDetails);
  },
  methods: {
    // 请求所有收费明细统计列表
    async getChargeDetails() {
      let { rows, code, total } = await chargeDetails1(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.chargeDetailsList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>